import { render, staticRenderFns } from "./FavouriteInspirations.vue?vue&type=template&id=5cf07e10&scoped=true"
import script from "./FavouriteInspirations.vue?vue&type=script&lang=js"
export * from "./FavouriteInspirations.vue?vue&type=script&lang=js"
import style0 from "./FavouriteInspirations.vue?vue&type=style&index=0&id=5cf07e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf07e10",
  null
  
)

export default component.exports